// global tools function
import { EXCLUDE_STORAGE_KEY, IFormRules } from '@/constants'

export const object2Str = (o: string | object): string => {
  return typeof o === 'string' ? o : JSON.stringify(o)
}

/*
 * 节流函数
 */
export const throttle = function(func: Function, wait: number) {
  let previous = 0
  return function(...args: any[]) {
    const now = Date.now()
    // const context = this;
    // const args = arguments;
    if (now - previous > wait) {
      func.apply(null, args)
      previous = now
    }
  }
}

/**
 * debounce
 * @param fn 执行函数
 * @param DETAL 默认300ms
 */
export const debounce = (fn: Function, DETAL?: number) => {
  let timer = 0
  return (...args: []) => {
    timer && clearTimeout(timer)
    timer = window.setTimeout(() => {
      fn.apply(null, args)
    }, DETAL || 300)
  }
}

/**
 * storage
 * 包含获取、设置、删除、清空方法
 * get(key: stirng): string
 * set(key: string, val: string): void
 * del(key: stirng): void
 * clear(): void
 */
export const storage = {
  get(key: string) {
    return localStorage.getItem(key) || ''
  },

  set(key: string, val: string) {
    localStorage.setItem(key, val)
  },

  del(key: string) {
    localStorage.removeItem(key)
  },

  clear(exclude?: boolean) {
    if (exclude) {
      Object.keys(localStorage).forEach(key => {
        if (!EXCLUDE_STORAGE_KEY.includes(key)) {
          localStorage.removeItem(key)
        }
      })
    } else {
      localStorage.clear()
    }
  }
}

/**
 *
 */
export const getFullDate = (): string => {
  const date = new Date(),
    Y = date.getFullYear(),
    M = date.getMonth() + 1,
    D = date.getDate()

  const MM = (M < 10 ? '0' : '') + M,
    DD = (D < 10 ? '0' : '') + D
  return Y + MM + DD
}

function fillZero(num: number): string {
  return (num < 10 ? '0' : '') + num
}
/*
 *
 */
export const dateFmt = (time: number | string, format?: string): string => {
  if (time === '' || time === 0) {
    return ''
  }
  try {
    time = time || Date.now()
    format = format || 'YYYY-MM-DD'
    let d = new Date(time)
    const regObj: IAnyObject = {
      YYYY: d.getFullYear(),
      YY: String(d.getFullYear()).substr(2, 4),
      MM: fillZero(d.getMonth() + 1),
      M: d.getMonth() + 1,
      DD: fillZero(d.getDate()),
      D: d.getDate(),
      HH: fillZero(d.getHours()),
      H: d.getHours(),
      mm: fillZero(d.getMinutes()),
      m: d.getMinutes(),
      ss: fillZero(d.getSeconds()),
      s: d.getSeconds(),
      SSS: d.getMilliseconds(),
      S: d.getMilliseconds()
    }
    for (let k in regObj) {
      if (format.indexOf(k) >= 0) {
        format = format.replace(new RegExp(k), regObj[k])
      }
    }
    return format
  } catch (e) {
    return ''
  }
}
/*
  js加减乘除
*/
export const jsOperation = (num1: number, num2: number, type: string) => {
  let baseNum, baseNum1, baseNum2
  try {
    baseNum1 = num1.toString().split('.')[1].length
  } catch (e) {
    baseNum1 = 0
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length
  } catch (e) {
    baseNum2 = 0
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
  if (type === 'add') {
    return (num1 * baseNum + num2 * baseNum) / baseNum
  } else if (type === 'minus') {
    const precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2
    return (num1 * baseNum - num2 * baseNum) / baseNum
  } else if (type === 'multi') {
    return (
      (Number(String(num1).replace('.', '')) *
        Number(String(num2).replace('.', ''))) /
      Math.pow(10, baseNum1 + baseNum2)
    )
  } else if (type === 'divi') {
    return (
      (Number(num1.toString().replace('.', '')) /
        Number(num2.toString().replace('.', ''))) *
      Math.pow(10, baseNum2 - baseNum1)
    )
  } else {
    return 0
  }
}

/**
 * 获取浏览器类型
 */
export const getClientType = () => {
  const u = navigator.userAgent
  if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    return { type: 'iOS', version: u.match(/iP[^;]+; CPU[^\d]+[\d+(_|.)]+/) }
  } else if (u.match(/Android/)) {
    return { type: 'Android', version: u.match(/Android ([\d.]+)/)![0] }
  } else if (u.match(/Trident/)) {
    return {
      type: 'IE',
      version: u.match(/(MSIE ([\d.]+))|(Trident\/[\d.]+)/)![0]
    }
  } else if (u.match(/Edge/)) {
    return { type: 'Edge', version: u.match(/Edge\/([\d.]+)/)![0] }
  } else if (u.match(/Chrome/)) {
    return { type: 'Chrome', version: u.match(/Chrome\/([\d.]+)/)![0] }
  } else if (u.match(/Firefox/)) {
    return { type: 'Firefox', version: u.match(/Firefox\/([\d.]+)/)![0] }
  } else if (u.match(/Safari/)) {
    return {
      type: 'Safari',
      version: u.match(/Safari\//)![0] + u.match(/Version\/([\d.]+)/)![1]
    }
  } else {
    return { type: u, version: null }
  }
}

/**
 * 获取现在的年月日等时间
 * Y:年, M:月, D:日, H:时, M:分, S:秒, s:毫秒, W:星期
 */
export const getNow = () => {
  const d = new Date()
  return {
    Y: d.getFullYear(),
    M: d.getMonth(),
    D: d.getDate(),
    H: d.getHours(),
    m: d.getMinutes(),
    S: d.getSeconds(),
    s: d.getMilliseconds(),
    W: d.getDay()
  }
}

/**
 * 表单验证返回类型
 */
export interface IValidResult {
  result: boolean // 验证结果
  fields: IAnyObject // 不通过字段集合
}

/**
 * 表单验证提示
 * @param field 提示的字段
 * @param vm 当前组件
 */
const formNotice = (field: string, vm: React.Component) => {
  try {
    const inputCom = vm.refs[field] as React.Component
    console.log(inputCom, 'inputCom')
    if (inputCom) {
      inputCom.setState({ valid: false })
    } else {
      throw Error(`the field's ref [${field}] is not defined.`)
    }
  } catch (e) {
    console.error(e)
  }
}

/**
 * 验证表单
 * @param data 表单数据
 * @param rules 规则(必须包含pattern才可验证)
 * @param vm 当前组件(用于提示)
 */
export const validForm = (
  data: IAnyObject,
  rules: IFormRules,
  vm?: React.Component
): IValidResult => {
  let fields = {}
  for (let key in rules) {
    const rule = rules[key], // 规则
      val = data[key] || '', // 默认为空字符串
      compare = rule.compare // 要比较的字段
    if (compare && (!val || val !== data[compare])) {
      fields[key] = key
      vm && formNotice(key, vm)
    }
    let reg = new RegExp(rule.pattern!)
    // console.log(reg, val)
    if (!reg.test(val)) {
      fields[key] = key
      vm && formNotice(key, vm)
    }
  }
  let result = Object.keys(fields).length === 0
  return { result, fields }
}

/**
 * 金额格式化
 * @param num 
 * @param len 
 */
export const numFormat = (num: number, len: number = 2) => {
  try {
    return num.toFixed(len).replace(/\B(?=(\d{3})+(\D|$))/g, ',')
  } catch (err) {
    return ''
  }
}
